export const mutations = {
  DRAWER_RESET: "DRAWER_RESET",
  INTEGRATION_FETCH_APPS: "INTEGRATION_FETCH_APPS"
}

export const actions = {
  INTEGRATION_FETCH_APPS: "fetchAppsIntegration"
}
